// removed by extract-text-webpack-plugin
module.exports = {"modal":"_9QpxU","modal--large":"_1YCcn","modal-background":"_2pASI _9QpxU","overlay":"_26LpG","close-button":"_2LBGk","light-close-button":"_2yaRD","dark-close-button":"_3nX6C"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.scss
// module id = ./src/components/Modal/Modal.scss
// module chunks = 4